import * as React from 'react';
import { useSelector } from 'react-redux';

var MaintenanceStatusWrapper = function MaintenanceStatusWrapper(_ref) {
  var maintenancePage = _ref.maintenancePage,
      children = _ref.children;
  var isUp = useSelector(function (state) {
    var _state$announcements;

    return (_state$announcements = state.announcements) === null || _state$announcements === void 0 ? void 0 : _state$announcements.maintenance;
  });

  if (isUp === false) {
    return maintenancePage;
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
};

export default MaintenanceStatusWrapper;
//# sourceMappingURL=MaintenanceStatusWrapper.js.map